<script lang="ts" setup>
import type { AppTabType } from '@libs/ui';
import { AppTabs } from '@libs/ui';

import { TabKey } from '../../models/configurationPanel.model';
import { useConfigurationPanelStore } from '../../stores';

interface ConfigurationPanelTabSelector {
  tabs: AppTabType[];
  isEditing: boolean;
}

const props = defineProps<ConfigurationPanelTabSelector>();

const configurationPanelStore = useConfigurationPanelStore();

function onTabClick(tabKey: string): void {
  const key = Object.values(TabKey).find((key) => key === tabKey);
  if (!props.isEditing && key) {
    configurationPanelStore.handleTabSwitch(key);
  }
}
</script>

<template>
  <div class="configuration-panel-tab-selector-wrapper">
    <AppTabs
      :tabs="tabs"
      :selected-tab-key="configurationPanelStore.getTabSelected"
      @tab-click="onTabClick"
    />
  </div>
</template>

<style lang="scss" scoped>
.configuration-panel-tab-selector-wrapper {
  position: relative;
  width: 100%;
  margin: 0 var(--spacing-24);
  @include for-less-or-equal-than-medium-max {
    margin: 0;
  }
}
</style>
